
import { defineComponent } from 'vue'
import { filterDefault } from '@/helpers/commons/filterHelper'
import Column from 'primevue/column'
import DataTable from 'primevue/datatable'
import hierarchyManagementDimensionsTableDescriptor from './HierarchyManagementDimensionsTableDescriptor.json'
import HierarchyManagementDimensionsInfoDialog from './HierarchyManagementDimensionsInfoDialog.vue'

export default defineComponent({
    name: 'hierarchy-management-dimensions-table',
    components: { Column, DataTable, HierarchyManagementDimensionsInfoDialog },
    props: { dimensionData: { type: Object } },
    data() {
        return {
            hierarchyManagementDimensionsTableDescriptor,
            rows: [] as any[],
            columns: [] as { field: string; header: string }[],
            filters: { global: [filterDefault] },
            globalFilterFields: [] as string[],
            selectedItem: [] as { value: string; label: string }[],
            infoDialogVisible: false
        }
    },
    watch: {
        dimensionData() {
            this.loadData()
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        loadData() {
            if (!this.dimensionData) return

            this.rows = this.dimensionData.root
            this.columns = this.dimensionData.columns
                ?.filter((column: any) => column.VISIBLE)
                .map((column: any) => {
                    return { field: column.ID, header: column.NAME }
                })
            this.globalFilterFields = this.dimensionData.columns_search
        },
        showInfo(item: any) {
            this.selectedItem = []
            Object.keys(item).forEach((key: string) => this.selectedItem.push({ label: this.getColumnLabel(key), value: item[key] }))
            this.infoDialogVisible = true
        },
        getColumnLabel(key: string) {
            if (!this.dimensionData) return
            const index = this.dimensionData.columns.findIndex((column: any) => column.ID === key)
            return index !== -1 ? this.dimensionData.columns[index].NAME : ''
        },
        onDragStart(event: any, item: any) {
            event.dataTransfer.setData('text/plain', JSON.stringify(item))
            event.dataTransfer.dropEffect = 'move'
            event.dataTransfer.effectAllowed = 'move'
        },
        closeInfoDialog() {
            this.selectedItem = []
            this.infoDialogVisible = false
        }
    }
})
